<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
               fullscreen
  >
    <factura-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-update>
</template>

<script>

import FacturaProvider from "../../../../providers/FacturaProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'
import {Dayjs} from '@dracul/dayjs-frontend'

import FacturaForm from "../FacturaForm";


export default {
  name: "FacturaUpdate",

  components: {FacturaForm, CrudUpdate},
  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'afip.factura.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        CantReg: this.item.CantReg,
        PtoVta: this.item.PtoVta,
        CbteTipo: this.item.CbteTipo,
        Concepto: this.item.Concepto,
        DocTipo: this.item.DocTipo,
        DocNro: this.item.DocNro,
        CbteDesde: this.item.CbteDesde,
        CbteHasta: this.item.CbteHasta,
        CbteFch: this.item.CbteFch,
        ImpTotal: this.item.ImpTotal,
        ImpTotConc: this.item.ImpTotConc,
        ImpNeto: this.item.ImpNeto,
        ImpOpEx: this.item.ImpOpEx,
        ImpIVA: this.item.ImpIVA,
        ImpTrib: this.item.ImpTrib,
        MonId: this.item.MonId,
        MonCotiz: this.item.MonCotiz,
        CAE: this.item.CAE,
        CAEFchVto: this.item.CAEFchVto,
        VoucherNumber: this.item.VoucherNumber,
        Error: this.item.Error,
        Estado: this.item.Estado,
        FchServDesde: this.item.FchServDesde?Dayjs(parseInt(this.item.FchServDesde)):null,
        FchServHasta: this.item.FchServHasta?Dayjs(parseInt(this.item.FchServHasta)):null,
        FchVtoPago: this.item.FchVtoPago?Dayjs(parseInt(this.item.FchVtoPago)):null,
        CondicionIVAReceptor: this.item.CondicionIVAReceptor,
        RazonSocialReceptor: this.item.RazonSocialReceptor,
        DomicilioReceptor: this.item.DomicilioReceptor,
        CondicionVenta: this.item.CondicionVenta,
        ProductoServicio: this.item.ProductoServicio,
        Alicuota: this.item.Alicuota,
        detalleProductoServicio: this.item.detalleProductoServicio ? this.item.detalleProductoServicio : [],
        Iva: this.item.Iva ? this.item.Iva : []
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        FacturaProvider.updateFactura(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateFactura)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

